<!-- ROW : PRODUCT COMPONENTS -->

<div class="ss-pc-list-main-container" [ngClass]="class" *ngIf="productComponentList && productComponentList.length > 0">
    <div class="ss-pc-list-label">{{"module.cart.itemFrame.label_product_components" | translate}} :</div>
    <div class="ss-pc-list-list-container">
        
        <table class="ss-pc-list-item-container">

            <!-- LOOP PRODUIT -->
            
            <tr *ngFor="let component of productList">
                <td class="ss-pc-list-item-text">{{"module.catalog.product-component.label_product" | translate}}</td>
                <td class="ss-pc-list-item-text">
                    <span>{{component.lineDescription01}}</span>
                    <span *ngIf="canSeePrice && deductProductComponentFromBudget &&component.includePriceInParent"> ({{ "module.catalog.product-component.label_price_included" | translate}})</span>
                </td>
                <td class="ss-pc-list-item-price" *ngIf="canSeePrice && deductProductComponentFromBudget">{{component.price | dollarSignByLocal}}</td>
                <td class="ss-pc-list-item-price" *ngIf="canSeePrice && deductProductComponentFromBudget"><span *ngIf="component.childQuantityMultiplicator > 1"> x{{component.childQuantityMultiplicator}}</span></td>
            </tr>

            <!-- LOOP NOTE -->
    
            <tr *ngFor="let component of noteList">
                <td class="ss-pc-list-item-text">{{"module.cart.itemFrame.note01" | translate}}</td>
                <td class="ss-pc-list-item-text" colspan="4">{{component.lineDescription01}}</td>
            </tr>   

        </table>
        
    </div>
</div>
